import { render, staticRenderFns } from "./authPasswordExpiredFields.vue?vue&type=template&id=dbef9b52&scoped=true"
import script from "./authPasswordExpiredFields.vue?vue&type=script&lang=js"
export * from "./authPasswordExpiredFields.vue?vue&type=script&lang=js"
import style0 from "./authPasswordExpiredFields.vue?vue&type=style&index=0&id=dbef9b52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbef9b52",
  null
  
)

export default component.exports